import {
  NEWDANHMUCKHACHHANG_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCKHACHHANG_HISTORY_LIST_SUCCESS,
  NEWDANHMUCKHACHHANG_IMPORT_SUCCESS,
  NEWDANHMUCKHACHHANG_LIST_SUCCESS,
  NEWDANHMUCKHACHHANG_NEW_CARE_SUCCESS,
  NEWDANHMUCKHACHHANG_ONE_SUCCESS,
  NEWDANHMUCKHACHHANG_UPDATE_FILTER,
  NEWDANHMUCKHACHHANG_SAVE_SUCCESS,
  NEWDANHMUCKHACHHANG_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCKHACHHANG_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCKHACHHANG_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCKHACHHANG_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmuckhachhang.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmuckhachhangFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmuckhachhangPage: 0,
    homepageNewdanhmuckhachhangLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmuckhachhangItems: [],
  homepageNewdanhmuckhachhangTotal: 0,
  homepageNewdanhmuckhachhangSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmuckhachhangReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCKHACHHANG_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCKHACHHANG_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCKHACHHANG_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCKHACHHANG_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmuckhachhangFilter !== 'undefined' && state.homepageNewdanhmuckhachhangFilter) {
        if (action.data.homepageNewdanhmuckhachhangPage == 'no_update' && typeof state.homepageNewdanhmuckhachhangFilter.homepageNewdanhmuckhachhangPage !== 'undefined') action.data.homepageNewdanhmuckhachhangPage = state.homepageNewdanhmuckhachhangFilter.homepageNewdanhmuckhachhangPage;
        if (action.data.homepageNewdanhmuckhachhangLimit == 'no_update' && typeof state.homepageNewdanhmuckhachhangFilter.homepageNewdanhmuckhachhangLimit !== 'undefined') action.data.homepageNewdanhmuckhachhangLimit = state.homepageNewdanhmuckhachhangFilter.homepageNewdanhmuckhachhangLimit;
      }
      return {
        ...state,
        homepageNewdanhmuckhachhangFilter: action.data,
      }
    }
    case NEWDANHMUCKHACHHANG_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmuckhachhangItems: action.data.homepageNewdanhmuckhachhangItems,
        homepageNewdanhmuckhachhangTotal: action.data.homepageNewdanhmuckhachhangTotal,
      }
    }
    case NEWDANHMUCKHACHHANG_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmuckhachhangSelected: action.data
      }
    }
    case NEWDANHMUCKHACHHANG_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCKHACHHANG_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCKHACHHANG_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCKHACHHANG_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCKHACHHANG_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCKHACHHANG_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmuckhachhangReducer